import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    private spinnerSubject = new Subject<boolean>();

    showSpinner() {
        this.spinnerSubject.next(true);
    }

    hideSpinner() {
        this.spinnerSubject.next(false);
    }

    getSpinnerObserver() {
        return this.spinnerSubject.asObservable();
    }
}
